import React, { useState, useEffect } from 'react';

import { modalStyle1024 } from '../../shared/commonStyle';

import { r2_updateData } from '../../../Helpers/r2_requests';

import Upload from '../../Upload/Upload';
import ViewUploads from '../../Upload/ViewUploads';

import { APIROOT } from '../../../Helpers/configs';

import { defineTicketNumber } from '../../../Helpers/helpers';

import RepairTicketCustomer from './RepairTicketCustomer';
import RepairTicketCabinet from './RepairTicketCabinet';
import RepairTicketType from './RepairTicketType';
import RepairTicketProcess from './RepairTicketProcess';

import { useLocation, useNavigate } from 'react-router-dom';

import { GetAuth } from '../../../Auth/AuthProvider';

import {
  Box,
  Grid,
  Typography,
  TextField,
  Button,
  Divider,
  Modal,
} from '@mui/material';
import { AddToPhotosOutlined as AddMoreIcon, Today } from '@mui/icons-material';

import { ticketTypoTitle, ticketTypoInfo } from '../../shared/commonStyle';

import UnauthorisedAccess from '../../CommonComponents/UnauthorisedAccess';

const RepairTicketAddEdit = (props) => {
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  const handleViewOpen = () => setViewOpen(true);
  const handleViewClose = () => setViewOpen(false);

  const location = useLocation();
  const ticketData = location.state;
  const navigateBack = useNavigate();

  const enqNotification = GetAuth().Notification; //Custom Hook - Returns a function which can be used to enque Notifications
  const logout = GetAuth().signOut; //Custom Hook - returns Signout function

  const [open, setOpen] = useState(false);
  const [viewOpen, setViewOpen] = useState(false);
  const [forceUpdate, setForceUpdate] = useState(1);

  const [useType, setUseType] = useState(localStorage.getItem('type'));
  const [cancelReason, setCancelReason] = useState(null);

  const [active, setactive] = useState(ticketData.active);

  const [ticketStatus, setTicketStatus] = useState(ticketData.status);
  // const [ticketStatus, setTicketStatus] = useState(ticketData.status);

  const [customerName, setCustomerName] = useState(ticketData.customer_name);
  const [customerInfo, setCustomerInfo] = useState({
    category: ticketData.customer_category_name,
    storeName: ticketData.customer_name,
    customerId: ticketData.customer_id,
    address: ticketData.customer_address,
    branchCode: ticketData.customer_branchcode,
    contactPerson: ticketData.customer_contact_name,
    contactNumber: ticketData.customer_contact_number,
    assetComp: ticketData.customer_asset_comp_name,
    wiNr: ticketData.wi_number,
    notify: ticketData.notify_customer,
    loggedBy: ticketData.creator_name,
    loggedByNumber: ticketData.creator_number,
  });

  const [description, setDescription] = useState(ticketData.description);
  const [serialsList, setSerialsList] = useState(ticketData.serial_numbers);
  const [cabCount, setCabCount] = useState(getLastId(serialsList));

  const [ticketTypeData, setTicketTypeData] = useState({
    ticketType:
      ticketData.ticket_type === 'repair'
        ? { id: '1', name: 'repair' }
        : { id: '2', name: 'upliftment' },
    techAssigned: {
      id: ticketData.tech_assigned,
      name: ticketData.tech_assigned_name,
    },
    assistantTech: {
      id: ticketData.assist_tech_assigned,
      name: ticketData.assist_tech_assigned_name,
    },
    subbieAssigned: {
      id: ticketData.sub_assigned,
      name: ticketData.sub_assigned_name,
    },
    subbieContactNr: ticketData.sub_contact,
    customer: ticketData.sub_customer,
  });

  const handlechange = (event) => {
    switch (event.target.id) {
      case 'description':
        setDescription(event.target.value);
        break;
      default:
        break;
    }
  };

  const handleCabRowsChange = async (arr) => {
    const result = await addCabinet(arr, cabCount);
    setCabCount((x) => x + 1);
    setSerialsList(result);
  };

  const deleteCabRow = (arr) => {
    setSerialsList(arr);
  };

  const updateRowV2 = (cabId, serialBlob) => {
    const arr2 = [...serialsList];

    let newArr = arr2.filter((cab) => {
      return cab.id !== cabId;
    });

    getLastId(serialsList);

    setSerialsList([...newArr, serialBlob]);
  };

  const isTechAssigned = () => {
    const techEmpty =
      ticketTypeData.techAssigned.id === null || undefined ? true : false;
    return techEmpty;
  };

  const handleTicketStatus = (status) => {
    let submitStatus;

    switch (status) {
      case 'new':
        break;

      default:
        break;
    }
  };

  const checkTechAssigned = () => {
    const status = ticketData.status.toLowerCase();

    if (
      status === 'new' ||
      status === 'logged' ||
      status === 'assigned' ||
      status === 'upliftment'
    ) {
      if (ticketTypeData.ticketType.name.toLowerCase() === 'upliftment') {
        return 'upliftment';
      }
      return ticketTypeData.techAssigned.id === null &&
        ticketTypeData.subbieAssigned.id === null
        ? 'logged'
        : 'assigned';
    }

    return ticketData.status;
  };

  const combineData = () => {
    handleTicketStatus(ticketStatus);

    let ticketBlob = {
      repair_ticket: {
        ticket_type: ticketTypeData.ticketType.name,
        status: checkTechAssigned(),
        description: description,
        serial_numbers: serialsList,
        customer_id: customerInfo.customerId,
        customer_contact_name: customerInfo.contactPerson,
        customer_contact_number: customerInfo.contactNumber,
        notify_customer: customerInfo.notify,
        wi_number: customerInfo.wiNr,
        tech_assigned:
          ticketTypeData.techAssigned.id === null
            ? null
            : ticketTypeData.techAssigned.id,
        assist_tech_assigned:
          ticketTypeData.assistantTech.id === null
            ? null
            : ticketTypeData.assistantTech.id,
        sub_assigned:
          ticketTypeData.subbieAssigned.id === null
            ? null
            : ticketTypeData.subbieAssigned.id,
        sub_contact:
          ticketData.subbieContactNr === null
            ? undefined
            : ticketTypeData.subbieContactNr === null
            ? ''
            : ticketTypeData.subbieContactNr,
        sub_customer:
          ticketTypeData.customer === null ? '' : ticketTypeData.customer,
        active: active,
        cancel_reason: '',
      },
    };

    return ticketBlob;
  };
  const cancelTicket = () => {
    let cancelBlob = {
      repair_ticket: {
        ticket_type: ticketTypeData.ticketType.name,
        customer_id: customerInfo.customerId,
        status: 'canceled',
        cancel_reason: cancelReason,
      },
    };
    return cancelBlob;
  };

  const cancelSave = () =>
    navigateBack(`/ticket`, {
      replace: true,
    });

  const ticketUpdate = () => {
    const action_message = 'Successfully Updated';
    const action_type = 'success';
    const nodePath =
      ticketStatus === 'new'
        ? '/r2_repair_tickets'
        : `/r2_repair_tickets/${ticketData.id}`;
    const cancelTrue =
      cancelReason === null ? false : cancelReason.length < 5 ? false : true;
    const dataBlob =
      // { ...combineData() };
      cancelTrue ? { ...cancelTicket() } : { ...combineData() };

    const path = '/ticket';
    const uri = nodePath;
    r2_updateData({
      uri: uri,
      dataBlob: dataBlob,
      cancelEdit: () => {},
      setForceUpdate,
      navigateBack,
      path: path,
      logout: logout,
      enqNotification: enqNotification,
      updateMessage: 'Repair ticket updated',
      action_message: 'done',
      type: 'repair ticket',
      state: 'repair',
    });
  };

  const [ticketDataReq, setTicketDataReq] = useState({});

  useEffect(() => {
    getTicketDatabyId(location.state.id).then((data) => {
      setTicketDataReq(data.data.value);
      // console.log(data.data.value);
    });
  }, [location.state]);

  return useType === 'technician' ? (
    <UnauthorisedAccess />
  ) : (
    <Box
      style={{
        minHeight: '20vh',
        maxWidth: '100%',
        textAlign: 'left',
        border: 'solid 2px #354775',
        background: '#ebedf8',
        borderRadius: '5px',
      }}
    >
      <Typography
        style={{
          background: '#354775',
          padding: '15px',
          border: 'solid 2px #354775',
          color: '#ffffff',
        }}
        variant='h5'
      >
        TICKET NR:{' '}
        {ticketData.id === null
          ? 'New Ticket'
          : defineTicketNumber(ticketData.ticket_type, ticketData.id, '5', 'R')}
      </Typography>
      <Box
        name='customerDetails'
        style={{
          minHeight: '20vh',
          maxWidth: '100%',
          textAlign: 'left',
          background: '#ebedf8',
          borderRadius: '5px',
          padding: '15px',
        }}
        s
      >
        <RepairTicketCustomer
          ticketId={ticketData.id}
          customerInfo={customerInfo}
          onNameChange={(name) => setCustomerName(name)}
          onCustomerInfoChange={(eventTarget, eventValue) => {
            setCustomerInfo({ ...customerInfo, [eventTarget]: eventValue });
            console.log(ticketData);
          }}
        />
      </Box>
      <Divider />
      <Box
        style={{
          // minHeight: '20vh',
          maxWidth: '100%',
          textAlign: 'left',
          borderRadius: '5px',
          padding: '0 15px 15px 15px',
        }}
      >
        <Grid container sx={{ marginTop: '15px' }}>
          <Grid item xs={12} lg={1.2}>
            <Typography style={ticketTypoTitle}>
              Problem/Issue Reported:
            </Typography>
          </Grid>
          <Grid item xs={12} lg={10.3}>
            <TextField
              size='small'
              sx={{
                width: '100%',
                background: '#ffffff',
                padding: 0,
              }}
              required
              id='description'
              defaultValue={description}
              onChange={handlechange}
            />
          </Grid>
        </Grid>
        <Button
          // disabled={
          //   customerInfo.storeName === '' ||
          //   customerInfo.storeName === undefined ||
          //   customerInfo.storeName === null
          //     ? true
          //     : false
          // }
          onClick={() => {
            handleCabRowsChange(serialsList);
          }}
          startIcon={<AddMoreIcon />}
          label='Add'
        >
          Add
        </Button>
        <Typography variant='h6'>Logged Cabinets:</Typography>{' '}
        {/* {console.log(customerInfo.storeName)} */}
        <RepairTicketCabinet
          serialsDataList={serialsList}
          // customerName={customerInfo.storeName}
          customerName={customerName}
          onBlurEventsCapture={(cabId, serialBlob) => {
            // console.log('INCOMING VALUE: ', cabId, serialBlob);
            updateRowV2(cabId, serialBlob);
          }}
          deleteCabinet={(arr, id) => deleteCabRow(arr, id)}
        />
      </Box>
      <Divider style={{ marginBottom: '15px' }} />
      <Box
        name='ticketDetails'
        style={{
          // minHeight: '20vh',
          maxWidth: '100%',
          textAlign: 'left',
          borderRadius: '5px',
          padding: '0 15px 15px 15px',
        }}
      >
        <RepairTicketType
          ticketTypeData={ticketTypeData}
          ticketStatus={ticketStatus}
          onTicketTypeDataChange={(eventTarget, eventValue) => {
            setTicketTypeData({ ...ticketTypeData, [eventTarget]: eventValue });
          }}
        />
      </Box>
      <Divider />
      <RepairTicketProcess
        ticketStatus={ticketStatus}
        cancelSave={cancelSave}
        handleOpen={handleOpen}
        handleOpenView={handleViewOpen}
        setCancel={() => {}}
        // cancelReason={cancelReason}
        ticketData={ticketData}
        cancelReason={(value) => setCancelReason(value)}
        onSave={() => {
          ticketUpdate();
        }}
      />
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby='modal-modal-title'
        aria-describedby='modal-modal-description'
      >
        <Box sx={modalStyle1024}>
          <Upload relationId={ticketData.id} relationType='repairTickets' />
        </Box>
      </Modal>
      <Modal
        open={viewOpen}
        onClose={handleViewClose}
        aria-labelledby='modal-modal-title'
        aria-describedby='modal-modal-description'
      >
        <Box sx={modalStyle1024}>
          <ViewUploads
            relationId={ticketData.id}
            relationType='repairTickets'
          />
        </Box>
      </Modal>
    </Box>
  );
};

export default RepairTicketAddEdit;

const addCabinet = (data, cabCount) => {
  let rowId = data.length > 0 ? data[data.length - 1].id + 1 : 0;
  let newObj = [
    {
      id: rowId,
      cabId: '',
      cabType: '',
      serialId: '',
      serialNo: '',
    },
  ];
  let newData = [...data, ...newObj];
  return new Promise((resolve) => {
    resolve(newData);
  });
};

const getLastId = (arr) => {
  const length = arr.length;
  const index = length > 0 ? length - 1 : length;
  return length === 0
    ? 0
    : arr[index].id === undefined
    ? 101
    : parseInt(arr[index].id);
};

//TICKET DATA
async function getTicketDatabyId(TicketId) {
  let JWT = localStorage.getItem('JWT_Key');
  let headers = {
    'content-type': 'application/JSON',
  };

  if (JWT) {
    headers['x-api-key'] = JWT;
  }

  let body = {};

  const request = new Request(`${APIROOT}/api/repair-tickets/${TicketId}`, {
    method: 'post',
    headers,
    body: JSON.stringify(body),
  });

  const response = await fetch(request);

  const data = response.json();
  return data;
}
